/* Filtre pe colectii: formularul de filtre + sortarea + paginarea se incarca fara refresh
   prin Section Rendering API; URL-ul se actualizeaza (partajabil, indexabil). */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__filtersInit) { return; }
    root.__filtersInit = true;

    var sectionId = root.getAttribute('data-section-id'),
        baseUrl = root.getAttribute('data-collection-url'),
        panel = root.querySelector('[data-filters-panel]'),
        main = root.querySelector('[data-collection-main]'),
        body = document.body,
        timer = null,
        controller = null,
        lastFocus = null;

    if (!panel || !main) { return; }

    function form() { return root.querySelector('[data-filters-form]'); }

    /* Colectiile cu landing de sub-categorii folosesc ?view=grid pentru lista de produse;
       filtrele/sortarea/paginarea trebuie sa pastreze parametrul, altfel "inapoi" ajunge pe landing. */
    function keepView(url) {
      var view = new URLSearchParams(window.location.search).get('view');
      if (!view) { return url; }
      var u = new URL(url, window.location.origin);
      if (!u.searchParams.has('view')) { u.searchParams.set('view', view); }
      return u.pathname + u.search;
    }

    function buildUrl() {
      var f = form(), params = new URLSearchParams();
      if (f) {
        new FormData(f).forEach(function (value, key) {
          if (value !== '' && value !== null) { params.append(key, value); }
        });
      }
      var qs = params.toString();
      return baseUrl + (qs ? '?' + qs : '');
    }

    function fetchAndRender(url, push) {
      url = keepView(url);
      if (controller) { controller.abort(); }
      controller = new AbortController();
      main.setAttribute('aria-busy', 'true');
      root.classList.add('is-loading');
      var sep = url.indexOf('?') >= 0 ? '&' : '?';
      fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { signal: controller.signal, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'),
              newPanel = doc.querySelector('[data-filters-panel]'),
              newMain = doc.querySelector('[data-collection-main]'),
              newCount = doc.querySelector('[data-results-text]'),
              oldCount = root.querySelector('[data-results-text]'),
              newBtn = doc.querySelector('[data-filters-open]'),
              oldBtn = root.querySelector('[data-filters-open]');
          if (newPanel) {
            var focused = document.activeElement, focusName = focused && focused.name, focusValue = focused && focused.value;
            panel.innerHTML = newPanel.innerHTML;
            if (focusName) {
              var again = panel.querySelector('[name="' + CSS.escape(focusName) + '"][value="' + CSS.escape(focusValue || '') + '"]') || panel.querySelector('[name="' + CSS.escape(focusName) + '"]');
              if (again) { again.focus({ preventScroll: true }); }
            }
          }
          if (newMain) { main.innerHTML = newMain.innerHTML; }
          if (newCount && oldCount) { oldCount.textContent = newCount.textContent; }
          if (newBtn && oldBtn) { oldBtn.innerHTML = newBtn.innerHTML; }
          if (push) { history.pushState({ collectionFilters: true }, '', url); }
          document.dispatchEvent(new CustomEvent('collection:updated', { detail: { root: root } }));
        })
        .catch(function (err) { if (err.name !== 'AbortError') { window.location.href = url; } })
        .then(function () {
          main.setAttribute('aria-busy', 'false');
          root.classList.remove('is-loading');
        });
    }

    function scheduleUpdate(delay) {
      clearTimeout(timer);
      timer = setTimeout(function () { fetchAndRender(buildUrl(), true); }, delay || 0);
    }

    function openPanel() {
      lastFocus = document.activeElement;
      body.classList.add('filters-open');
      var btn = root.querySelector('[data-filters-open]');
      if (btn) { btn.setAttribute('aria-expanded', 'true'); }
      var first = panel.querySelector('input, select, button');
      if (first) { first.focus({ preventScroll: true }); }
    }
    function closePanel() {
      body.classList.remove('filters-open');
      var btn = root.querySelector('[data-filters-open]');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); }
      if (lastFocus && lastFocus.focus) { lastFocus.focus({ preventScroll: true }); }
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.closest('[data-filters-form]')) { return; }
      if (t.classList.contains('filters__price-input')) { scheduleUpdate(600); } else { scheduleUpdate(0); }
    });
    root.addEventListener('input', function (e) {
      if (e.target.classList.contains('filters__price-input')) { e.target.value = e.target.value.replace(/[^0-9]/g, ''); scheduleUpdate(700); }
    });
    root.addEventListener('submit', function (e) {
      if (e.target.matches('[data-filters-form]')) {
        e.preventDefault();
        clearTimeout(timer);
        fetchAndRender(buildUrl(), true);
        closePanel();
        var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
        if (window.innerWidth <= 960) { window.scrollTo({ top: top, behavior: 'smooth' }); }
      }
    });
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-filter-link]');
      if (link) { e.preventDefault(); fetchAndRender(link.getAttribute('href'), true); return; }
      var page = e.target.closest('[data-collection-main] .pagination a');
      if (page) {
        e.preventDefault();
        fetchAndRender(page.getAttribute('href'), true);
        var top = main.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
        return;
      }
      if (e.target.closest('[data-filters-open]')) { openPanel(); return; }
      if (e.target.closest('[data-filters-close]')) { closePanel(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && body.classList.contains('filters-open')) { closePanel(); }
    });
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.collectionFilters) { fetchAndRender(location.href, false); }
    });
  }

  // inaltimea header-ului lipicios -> --header-height (offset pentru sidebar-ul sticky)
  function measureHeader() {
    var bar = document.querySelector('.header .fixed') || document.querySelector('.header .bar') || document.querySelector('.header');
    if (bar) { document.documentElement.style.setProperty('--header-height', Math.round(bar.getBoundingClientRect().height) + 'px'); }
  }
  window.addEventListener('resize', measureHeader);
  window.addEventListener('scroll', function () { if (!measureHeader.__t) { measureHeader.__t = setTimeout(function () { measureHeader.__t = null; measureHeader(); }, 200); } }, { passive: true });

  function boot() { measureHeader(); document.querySelectorAll('[data-collection-root]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
